import React, { useMemo } from 'react';

export default function QCXDynamicFieldGroup({ rootName, list = [], children, keysProps = null }) {
  const generatedObjectsProps = useMemo(() => {

    let obj = {
      identificacao: undefined,
      valorReal: undefined,
      valorSiscomex: undefined,
      codigoReceita: undefined,
      novoCodigoReceita: undefined,
    };

    if (keysProps) {
      obj = {...keysProps}
    }

    const keys = Object.keys(obj);

    const result = list.map((...args) => ({
      ...keys.reduce(
        (previous, currentKey) => ({
          ...previous,
          [currentKey]: {
            name: `${rootName}[${args[1]}].${currentKey}`,
          },
          ...{
            props: args[0] ? {...args[0]} : {},
          },
        }),
        {}
      ),
    }));

    return result;
  }, [list, rootName]);

  return <>{generatedObjectsProps.map((item, index) => children({ ...item, index }))}</>;
}
